export const interpolate = (
  template: string | undefined,
  vars: Record<string, string | number> = {},
): string => {
  if (template === undefined) console.warn('interpolate: template is undefined')
  return (template ?? '').replace(/\{\{(\w+)\}\}/g, (match, key) => // SAFE: empty string when template not yet loaded
    key in vars ? String(vars[key]) : match,
  )
}
